import { contextFactory } from '../../../../hooks';
import { UseDataPickerDialogResponse } from '../date-picker/use-date-picker';
import { DateNavigatorProviderUniqueProps, DateNavigatorFormattedDate } from './date-navigator.types';

export type DateNavigatorContextValue = {
  value: string;
  datePickerDialogProps: UseDataPickerDialogResponse;
  formattedDateObj: DateNavigatorFormattedDate;
  showError: boolean;
  onChange: DateNavigatorProviderUniqueProps['onChange'];
  setOriginalValue: (value: string | null) => void;
  errorElement?: React.ReactNode;
};

export const [dateNavigatorContext, useDateNavigatorContext] =
  contextFactory<DateNavigatorContextValue>('DateNavigatorContext');
